import { errors, BackendError } from './errors';

const codeErrorMap: Readonly<Record<number | string, typeof BackendError>> = {
    ...errors,
};

type CreateErrorArgs = {
    message?: string;
    code?: number | string;
    url?: string;
    response?: unknown;
};

type ErrorKey = keyof typeof errors;

const createError = ({
    message,
    code = 0,
    url = '',
    response,
}: CreateErrorArgs): BackendError => {
    if (typeof code === 'string' && code in errors) {
        return new errors[code as ErrorKey](message, code, url, response);
    } else {
        return new (codeErrorMap[code] ?? BackendError)(
            message,
            code,
            url,
            response
        );
    }
};

export { createError };
